import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateFirestopListAttributes = async (
  projectId,
  firestopListId,
  firestopListAttributeModifications
) => {
  const apiPath = `firestop-documentation/project/${projectId}/list/${firestopListId}/update-firestop-list`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {
      firestopListAttributeModifications,
    },
    isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);

  return response.data;
};
